const EXCEL_COLUMNS = [
  "Employee ID",
  "Employee Name",
  "Department",
  "Date",
  "Day",
  "Check In",
  "Check Out",
  "Working Hours",
  "Late",
  "Half Day",
  "Day Status",
  "WFH",
  "Leave Type",
  "Leave Status",
  "Check-In Source",
  "Work Mode",
  "Break (min)",
  "Notes",
];

const SHEET_NAME_MAX = 31;

function sanitizeSheetName(name) {
  return String(name || "Employee")
    .replace(/[\\/?*[\]:]/g, "-")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, SHEET_NAME_MAX) || "Employee";
}

function uniqueSheetName(base, used) {
  let name = sanitizeSheetName(base);
  if (!used.has(name)) {
    used.add(name);
    return name;
  }
  let i = 2;
  while (i < 100) {
    const suffix = ` (${i})`;
    const trimmed = sanitizeSheetName(`${base.slice(0, SHEET_NAME_MAX - suffix.length)}${suffix}`);
    if (!used.has(trimmed)) {
      used.add(trimmed);
      return trimmed;
    }
    i += 1;
  }
  return uniqueSheetName(`Sheet-${used.size + 1}`, used);
}

function employeeSheetLabel(employeeName, employeeId) {
  return `${employeeName || "Employee"} (${employeeId || "—"})`;
}

function groupRowsByEmployee(rows) {
  const map = new Map();
  for (const row of rows || []) {
    const key = row.employeeId || "unknown";
    if (!map.has(key)) {
      map.set(key, {
        employeeId: row.employeeId,
        employeeName: row.employeeName,
        rows: [],
      });
    }
    map.get(key).rows.push(row);
  }
  return [...map.values()].sort((a, b) =>
    String(a.employeeName || "").localeCompare(String(b.employeeName || ""))
  );
}

export function buildAttendanceExportRows(rows) {
  return (rows || []).map((r) => ({
    "Employee ID": r.employeeId || "",
    "Employee Name": r.employeeName || "",
    Department: r.department || "",
    Date: r.date || "",
    Day: r.day || "",
    "Check In": r.checkIn || "",
    "Check Out": r.checkOut || "",
    "Working Hours": r.workingHours || "",
    Late: r.late || "",
    "Half Day": r.halfDay || "",
    "Day Status": r.dayStatus || "",
    WFH: r.wfh || "",
    "Leave Type": r.leaveType || "",
    "Leave Status": r.leaveStatus || "",
    "Check-In Source": r.checkInSource || "",
    "Work Mode": r.workMode || "",
    "Break (min)": r.breakMinutes ?? "",
    Notes: r.notes || "",
  }));
}

function appendSheet(wb, XLSX, sheetName, rows) {
  const data = buildAttendanceExportRows(rows);
  const ws = data.length
    ? XLSX.utils.json_to_sheet(data, { header: EXCEL_COLUMNS })
    : XLSX.utils.aoa_to_sheet([EXCEL_COLUMNS]);
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
}

export async function downloadAttendanceReportExcel(
  rows,
  filenamePrefix = "team-attendance",
  { splitByEmployee = false } = {}
) {
  const XLSX = await import("xlsx");
  const wb = XLSX.utils.book_new();
  const usedNames = new Set();

  if (splitByEmployee) {
    const groups = groupRowsByEmployee(rows);
    for (const group of groups) {
      const label = employeeSheetLabel(group.employeeName, group.employeeId);
      const sheetName = uniqueSheetName(label, usedNames);
      appendSheet(wb, XLSX, sheetName, group.rows);
    }
  } else {
    appendSheet(wb, XLSX, "Attendance", rows);
  }

  const date = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `${filenamePrefix}-${date}.xlsx`);
}
